/* eslint-disable better-mutation/no-mutation */
'use strict';

import { isServer } from 'tradera/utils/nextjs';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation may not compatible with SSR where global properties are shared between server instances'
    );
}

const EventEmitter = (function () {
    const _queue = {};

    const _dispatch = function (event, payload) {
        const callbacks = _queue[event];

        if (typeof callbacks === 'undefined') {
            return false;
        }

        callbacks.forEach(function (callback) {
            callback(payload);
        });

        return true;
    };

    const _subscribe = function (event, callback) {
        if (typeof _queue[event] === 'undefined') {
            _queue[event] = [];
        }

        _queue[event].push(callback);
    };

    return {
        dispatch: _dispatch,
        subscribe: _subscribe
    };
})();

export default EventEmitter;
